import React, { useEffect, useState } from "react";
import styles from "./OpenBooster.module.css";
import Card from "../../Cards/Card";
import { useNavigate, useParams } from "react-router-dom";
import {
  boosterData,
  getBoosterById,
  getRandomCardsForBooster,
} from "../../../services/BoosterServices";
import { CardData } from "../../../services/CardServices";
import Booster from "../Booster";
import globalStyles from "../../../styles/globalStyles.module.css";
import { useAlert } from "../../../context/AlertProvider";
import { useOpenBoosterContext } from "../../../context/OpenBoosterProvider";

const OpenBooster: React.FC = () => {
  const { boosterId } = useParams<{ boosterId: string }>();
  const [hiddenCards, setHiddenCards] = useState<number[]>([]);
  const [allRevealed, setAllRevealed] = useState<boolean>(false);
  const [cards, setCards] = useState<CardData[]>();
  const [booster, setBooster] = useState<boosterData>();
  const [IsBoosterClicked, setIsBoosterClicked] = useState<boolean>(false);
  const { setBoostersId } = useOpenBoosterContext();
  const { showAlert } = useAlert();

  useEffect(() => {
    const id = boosterId; // Convert `id` to an integer
    if (!id) {
      showAlert("You cannot open this booster");
      return;
    }
    const fetchBooster = async () => {
      const fetchBooster = await getBoosterById(id);
      setBooster(fetchBooster);
    };
    fetchBooster();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boosterId]);

  useEffect(() => {
    if (hiddenCards.length === 9) setAllRevealed(true);
  }, [hiddenCards]);

  const navigate = useNavigate();

  const redirectBack = () => {
    navigate(-1);
  };

  const revealAllCards = () => {
    setAllRevealed(true);
  };

  const revealCard = (card_id: number) => {
    setHiddenCards((prev) => [...prev, card_id]);
  };

  const handleBoosterClick = async () => {
    const id = boosterId;
    try {
      if (!id) {
        showAlert("You cannot open this booster");
        redirectBack();
        return;
      }
      const fetchedCardsId = await getRandomCardsForBooster(id);
      setCards(fetchedCardsId);
      setIsBoosterClicked(true);
      setBoostersId((prev) => {
        const index = prev.indexOf(boosterId);
        if (index === -1) return prev;
        return [...prev.slice(0, index), ...prev.slice(index + 1)];
      });
    } catch {
      showAlert("You cannot open this booster");
      redirectBack();
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {booster && !IsBoosterClicked && (
          <div className={styles.booster} onClick={handleBoosterClick}>
            <Booster
              booster={booster}
              isInStore={true}
              disableHover={true}
              disableClick={true}
            />
          </div>
        )}
        {IsBoosterClicked && (
          <>
            <div className={styles.pullcardsContainer}>
              <div className={styles.cardsGrid}>
                {cards &&
                  cards.map((card, index) => (
                    <div
                      key={index}
                      className={styles.cardItem}
                      onClick={() => revealCard(index)}
                    >
                      <Card
                        cardData={card}
                        isHiddenProp={
                          hiddenCards[card.id] == null && !allRevealed
                        }
                      />
                    </div>
                  ))}
              </div>
            </div>
            <button
              className={`${globalStyles.button}`}
              onClick={allRevealed ? redirectBack : revealAllCards}
            >
              {allRevealed ? "Continue" : "Reveal all cards"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default OpenBooster;
